import { useId } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import type { ReactNode } from 'react';

import { CloseIcon } from './Icons';

type ModalProps = {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  children: ReactNode;
  wide?: boolean;
};

export function Modal({ open, title, description, onClose, children, wide = false }: ModalProps) {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="modal-root"
      aria-labelledby={titleId}
      aria-describedby={description ? descriptionId : undefined}
      transition>
      <DialogBackdrop className="modal-backdrop" transition />

      <div className="modal-viewport">
        <DialogPanel className={`modal-sheet${wide ? ' wide' : ''}`} transition>
          <div className="modal-header">
            <div className="modal-header-copy">
              <DialogTitle id={titleId} className="modal-title">
                {title}
              </DialogTitle>
              {description ? (
                <p id={descriptionId} className="modal-description">
                  {description}
                </p>
              ) : null}
            </div>

            <button className="close-button" onClick={onClose} type="button" aria-label="Close">
              <CloseIcon size={18} />
            </button>
          </div>

          <div className="modal-body">{children}</div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
